import { render, staticRenderFns } from "./DeleteNotePanel.vue?vue&type=template&id=00117ad0&"
import script from "./DeleteNotePanel.vue?vue&type=script&lang=js&"
export * from "./DeleteNotePanel.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports